import OverviewEU from './VersionEU';
// import OverviewDE from './VersionDE';
import { useGlobal } from '@/utils/useGlobal';

export default function CollectionH5() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <>
            {locale === 'eu' && <OverviewEU />}
            {locale === 'uk' && <OverviewEU />}
            {locale === 'de' && <OverviewEU />}
        </>
    );
}
